import Navbar from 'components/navbar';
import { Outlet } from 'react-router-dom';

const BulkEditUpdatedHoc = () => {
  return (
    <div>
      <Navbar heading="FDP Updated - Unconstrained Forecast Bulk Edit" searchComponent={<></>} progressComponent={<></>} />
      <Outlet />
    </div>
  );
};

export default BulkEditUpdatedHoc;
